// DoubleCheck.js
export class DoubleCheck {

    // ========= GENERIC CONFIRM POPUP =========
    static confirm({
                       title = "Confirmation",
                       text = "Are you sure?",
                       onConfirm = () => {
                       },
                       confirmText = "Continue",
                       cancelText = "Cancel"
                   } = {}) {

        const existing = document.querySelector(".popup.active");
        if (existing) existing.remove();

        const modal = document.createElement("div");
        modal.classList.add("popup", "active");
        modal.innerHTML = `
            <div class="popup-wrapper" role="dialog" aria-modal="true">
                <button class="close" aria-label="Close">&times;</button>
                <h2>${title}</h2>
                <p>${text}</p>
                <div class="button-wrapper">
                    <button class="button green" id="pp-confirm">${confirmText}</button>
                    <button class="button red" id="pp-cancel">${cancelText}</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        const cleanup = () => {
            modal.classList.remove("active");
            setTimeout(() => modal.remove(), 200);
            modal.removeEventListener("click", backdrop);
            document.removeEventListener("keydown", esc);
        };

        const esc = (e) => {
            if (e.key === "Escape") cleanup();
        };
        const backdrop = (e) => {
            if (e.target === modal) cleanup();
        };

        modal.querySelector("#pp-confirm").onclick = () => {
            onConfirm();
            cleanup();
        };
        modal.querySelector("#pp-cancel").onclick = cleanup;
        modal.querySelector(".close").onclick = cleanup;

        modal.addEventListener("click", backdrop);
        document.addEventListener("keydown", esc);

        modal.querySelector("#pp-confirm").focus();
    }


    // ========= AUTOMATIC BINDING =========
    static bindDoublecheckAttributes(options = {}) {
        const hasUnsavedForms = options.hasUnsavedForms || (() => false);
        const clearGuards = options.clearGuards || (() => {
        });

        // Helper to open link respecting target, rel, download, etc.
        const navigateElement = (el) => {
            const href = el.dataset.hrefOriginal;
            if (!href) return;

            const target = el.getAttribute("target") || "_self";
            const rel = el.getAttribute("rel") || "";
            const download = el.getAttribute("download") || null;

            if (download) {
                // force download
                const a = document.createElement("a");
                a.href = href;
                a.download = download === "" ? true : download;
                document.body.appendChild(a);
                a.click();
                a.remove();
                return;
            }

            if (target === "_self") {
                window.location.href = href;
            } else {
                window.open(href, target, rel);
            }
        };

        // ========= DOUBLECHECK ATTRIBUTE =========
        document.querySelectorAll("[doublecheck]").forEach(el => {
            if (el.dataset.doublecheckBound) return;
            el.dataset.doublecheckBound = "1";

            const originalHref = el.getAttribute("href");
            if (originalHref && originalHref !== "#") {
                el.dataset.hrefOriginal = originalHref;
                el.setAttribute("href", "#");
            }

            el.addEventListener("click", e => {
                e.preventDefault();

                DoubleCheck.confirm({
                    title: el.dataset.title || "Confirmation",
                    text: el.dataset.content || "Are you sure?",
                    onConfirm: () => {
                        clearGuards();
                        navigateElement(el);
                    }
                });
            });
        });


        // ========= AUTO-GUARD NORMAL LINKS WHEN UNSAVED FORMS EXIST =========
        document.querySelectorAll("a:not([doublecheck]):not([ignorecheck])").forEach(el => {
            if (el.dataset.doublecheckBound) return;
            el.dataset.doublecheckBound = "1";

            const originalHref = el.getAttribute("href");
            if (!originalHref || originalHref === "#") return;

            el.dataset.hrefOriginal = originalHref;
            el.setAttribute("href", "#");

            el.addEventListener("click", e => {
                e.preventDefault();

                if (!hasUnsavedForms()) {
                    clearGuards();
                    navigateElement(el);
                    return;
                }

                DoubleCheck.confirm({
                    title: "Unsaved changes",
                    text: "You have unsaved changes. Leave this page?",
                    onConfirm: () => {
                        clearGuards();
                        navigateElement(el);
                    }
                });
            });
        });
    }
}